
    import './styles.scoped.css';
    export default {
  "root": "awsui_root_1om0h_im8v7_5"
};
  